import { useTranslations } from "@/lib/i18n/intl";
import { keys } from "@/lib/i18n/portal";
import { useProfileQuery } from "@/modules/profile/services/useProfileQuery";
import { ProfileForm } from "@/modules/profile/components/ProfileForm";
import { ProfilePasswordForm } from "@/modules/profile/components/ProfilePasswordForm";
import { LoadingSkeleton, ErrorState, SectionCard } from "@a2z/ui";

export function ProfilePage() {
  const t = useTranslations();
  const { data: admin, isLoading, error, refetch } = useProfileQuery();

  if (isLoading) {
    return <LoadingSkeleton variant="list" rows={2} />;
  }

  if (error || !admin) {
    return <ErrorState onRetry={refetch} />;
  }

  return (
    <section className="mx-auto flex w-full max-w-3xl flex-col gap-5 lg:px-6 lg:py-6">
      <h1 className="text-[23px] font-bold leading-tight tracking-[-0.025em] lg:text-[28px] lg:font-semibold lg:tracking-[-0.01em] text-[color:var(--text-primary)]">
        {t(keys.admin.profileTitle)}
      </h1>

      <SectionCard title={t(keys.admin.profileTitle)} icon={<UserIcon />}>
        <ProfileForm
          defaultValues={{
            name: admin.name,
            email: admin.email,
            phone: admin.phone,
          }}
        />
      </SectionCard>

      <SectionCard title={t(keys.admin.passwordTitle)} icon={<LockIcon />}>
        <ProfilePasswordForm />
      </SectionCard>
    </section>
  );
}

const SVG_PROPS = {
  width: 16,
  height: 16,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor" as const,
  strokeWidth: 2,
  strokeLinecap: "round" as const,
  strokeLinejoin: "round" as const,
  "aria-hidden": true,
};

function UserIcon() {
  return (
    <svg {...SVG_PROPS}>
      <circle cx="12" cy="8" r="4" />
      <path d="M4 21a8 8 0 0 1 16 0" />
    </svg>
  );
}

function LockIcon() {
  return (
    <svg {...SVG_PROPS}>
      <rect x="3" y="11" width="18" height="11" rx="2" />
      <path d="M7 11V7a5 5 0 0 1 10 0v4" />
    </svg>
  );
}
